// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { generateHeaders, createResponseObj } from '..'
import { vcBaseUrl } from '.'


type CancelGroupResponse = SuccessResponse | FailedResponse

export class CancelGroupRequest extends Request {
    private constructor(groupId: string, init?: RequestInit) { super(`${vcBaseUrl}/group/${groupId}/cancel`, init) }
    static async init(groupId: string, init?: RequestInit) {
        return new CancelGroupRequest(groupId, {
            ...init,
            method: 'PUT',
            headers: await generateHeaders("Clerk-Token", init?.headers),
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<void> {
        const response = await fetch(this)
        const data = createResponseObj<CancelGroupResponse>(await response.json())
        console.info("Cancel Group Results:", data)
        // ToDo: Handle 400 response - Attempt Cancel a locked group
    
        switch (data.status) {
            case 'successful': return
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}